<template>
  <div>
    <div class="ml-4 mr-4">
      <edit-form
        :disabled="isDisableEditForm"
        :funcID="funcID"
        :isAdd="isAdd"
        :classLevel="classLevel"
        ref="editForm"
        @close="close"
      />
      <div class="d-flex justify-content-end mb-2 mt-2">
        <el-button
          v-if="!isDisableEditForm"
          type="primary"
          size="small"
          @click="save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'system-menuMaintenance-detail',
  components: {
    EditForm,
  },
  props: {
    pageType: {
      type: String,
      default: '',
    },
    funcID: {
      type: String,
      default: '',
    },
    classLevel: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
  computed: {
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
    isAdd() {
      return this.pageType === 'add'
    },
  },
  methods: {
    save() {
      this.$refs.editForm.save()
    },
    close() {
      this.$emit('closeDrawer')
    }
  },
}
</script>
